import React, { useEffect, useState } from 'react'
import useNav from '../../../hooks/useNav'
import { Button } from '../../../components/ui/button'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { endOfMonth, format, startOfMonth } from 'date-fns'
import axios from '../../../lib/axios'
import { useAuth } from '../../../context/AuthProvider';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table'
import { ArrowLeftIcon } from 'lucide-react'
import { Trans, useLingui } from '@lingui/react/macro';

const MonthPage = () => {
    const { auth } = useAuth()
    const { t } = useLingui()
    const { nav, setNav } = useNav()

    const [selectedMonth, setSelectedMonth] = useState(new Date());

    const { data:overview } = useQuery({
        queryKey: [`overview-${format(selectedMonth, "MM")}`],
        queryFn: async () => {
            const { data } = await axios.get(`overview/month`, {
                params: {
                    dbid: auth.data?.databases[0].dbid,
                    technicianid: auth.data?.databases[0].technicianid,
                    startdate: format(startOfMonth(selectedMonth), "yyyyMMdd"),
                    enddate: format(endOfMonth(selectedMonth), "yyyyMMdd"),
                }
            })
            return data
        }
    })


    useEffect(()=>{
        setNav({...nav, title:t`Kalender - maandoverzicht`})
    }, [])

  return (
    <div className='flex flex-col gap-4 p-2 sm:p-4'>
        <div>
            <Link to=".."><Button variant='outline'><ArrowLeftIcon className='w-4 h-4'/><Trans>Dag overzicht</Trans></Button></Link>
        </div>
        
        <div className='flex items-center justify-between'>
            {overview && <p className='text-sm'><Trans>Totaal aantal uur: {overview?.totalhours}</Trans></p>}
        </div>
        
        <div className='overflow-auto border rounded-md'>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead><Trans>Dag</Trans></TableHead>
                        <TableHead><Trans>Aantal uur</Trans></TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array.isArray(overview?.days) && overview.days.map((day:any, index:number)=>(
                        <TableRow key={`day-${index}`}>
                            <TableCell>{day?.day}</TableCell>
                            <TableCell>{day?.hours}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    </div>
  )
}

export default MonthPage